const ImageFilters = {};
ImageFilters.utils = {
    initSampleCanvas: function() {
        const _canvas = document.createElement('canvas'),
            _context = _canvas.getContext('2d');

        _canvas.width = 0;
        _canvas.height = 0;

        this.getSampleCanvas = function() {
            return _canvas;
        };
        this.getSampleContext = function() {
            return _context;
        };
        this.createImageData = (_context.createImageData) ? function(w, h) {
            return _context.createImageData(w, h);
        } : function(w, h) {
            return new ImageData(w, h);
        };
    },
    getSampleCanvas: function() {
        this.initSampleCanvas();
        return this.getSampleCanvas();
    },
    getSampleContext: function() {
        this.initSampleCanvas();
        return this.getSampleContext();
    },
    createImageData: function(w, h) {
        this.initSampleCanvas();
        return this.createImageData(w, h);
    },
};

ImageFilters.Brown = function(srcImageData) {
    const srcPixels = srcImageData.data,
        srcWidth = srcImageData.width,
        srcHeight = srcImageData.height,
        srcLength = srcPixels.length,
        dstImageData = this.utils.createImageData(srcWidth, srcHeight),
        dstPixels = dstImageData.data;

    for (let i = 0; i < srcLength; i += 4) {
        dstPixels[i] = 104;
        dstPixels[i + 1] = 79;
        dstPixels[i + 2] = 53;
        dstPixels[i + 3] = srcPixels[i + 3];
    }

    return dstImageData;
};

export default ImageFilters;
